module.exports = __webpack_public_path__ + "static/media/map-marker-smile.5f7fa5ba.svg";